module.exports = __webpack_public_path__ + "static/media/small-logo.d4092236.svg";